import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    marginTop: 30,
    maxWidth: '100%',
    height: '100% ',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    backgroundColor: Colors.lightGray,
    padding: '1.25rem',
    borderRadius: 5,
    border: `1px solid ${Colors.gray}`,
    gap: '1rem',
  },
  
  formWrapper: {
    width: '100%',
    backgroundColor: Colors.white,
    display: 'flex',
    flexDirection: 'column',
    padding: '2rem',
    gap: '1rem',
  },
  
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '1rem 0 0',
    gap: '1rem',
  },
  
  questionConfirmation: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    fontSize: '1.5rem',
    wordWrap: 'break-word',
    
    '& p > span': {
      fontWeight: 600,
      wordWrap: 'break-word',

    },
    '& > div': {
      marginTop: 10,
      fontStyle: 'italic',
      fontSize: '1.5rem',
      border: `1px solid ${Colors.mediumLightGray}`,
      borderRadius: 3,
      padding: '1rem',
    },
  },
  
}))

export default styles
